import useAxios from './useAxios'
import { useQuery } from 'react-query/react'

interface DiscountTokenResponse {
  plan_code: string
  currency: {
    currency_code: string
    symbol: string
  }
  currency_code: string
  currency_symbol: string
  sticker_price: number
  discount_type: string
  discount_percent: number
  discount_value: number
  discount_token: string
  anon_id?: string | null
  expires_at: string
  expired: string
  redeemed: string
  short_description: string
  plan_name?: string
  addons?: string[]
}

interface UseDiscountReturns {
  isLoading: boolean
  isError: boolean
  data: DiscountTokenResponse | undefined | null
}

export default function useDiscountCode(
  planCode: string | undefined,
  discountToken: string | null | undefined
): UseDiscountReturns {
  const axios = useAxios()

  const fetchDiscount = async (
    planCode: string | undefined,
    discountToken: string | null | undefined
  ) => {
    const res = await axios.get<DiscountTokenResponse>(
      `/api/v2/check_discount`,
      {
        params: {
          p: planCode,
          dt: discountToken,
        },
        validateStatus: (status) => status === 200 || status === 404,
      }
    )

    if (res.status === 404) {
      return null
    }

    return res.data
  }

  const { isLoading, isError, data } = useQuery(
    ['discount', planCode, discountToken],
    () => fetchDiscount(planCode, discountToken),
    // We dont need the discount information to go stale as this information doesnt change often
    // Should we use Infinity. Im doing 12 hours right now
    {
      staleTime: 12 * 60 * 60 * 1000, //Infinity,
      enabled: !!discountToken,
    }
  )

  return {
    isLoading,
    isError,
    data,
  }
}
